export default "__VITE_ASSET__56996a76__"